// Form option constants shared across products, shops, and shipping forms

export const CURRENCIES = [
  { value: 'comoros_currency', label: 'KMF (Franc Comorien)' },
  { value: 'european_currency', label: 'EUR (Euro)' },
  { value: 'american_currency', label: 'USD (Dollar)' },
] as const;

export const UNITS = [
  { value: 'sold_individually', labelKey: 'products.units.sold_individually' },
  { value: 'sold_in_groups', labelKey: 'products.units.sold_in_groups' },
  { value: 'grams', labelKey: 'products.units.gram' },
  { value: 'kilogram', labelKey: 'products.units.kg' },
  { value: 'milliliter', labelKey: 'products.units.ml' },
  { value: 'liter', labelKey: 'products.units.liter' },
] as const;

export const GENDERS = [
  { value: 'none', labelKey: 'products.genders.none' },
  { value: 'men', labelKey: 'products.genders.men' },
  { value: 'women', labelKey: 'products.genders.women' },
  { value: 'both', labelKey: 'products.genders.both' },
] as const;

export const WEIGHT_UNITS = [
  { value: 'grams', label: 'Grammes (g)' },
  { value: 'kilograms', label: 'Kilogrammes (kg)' },
  { value: 'pounds', label: 'Livres (lb)' },
  { value: 'ounces', label: 'Onces (oz)' },
] as const;

// Subset for edit mode (products/[id]/edit.tsx uses only grams and kilograms)
export const WEIGHT_UNITS_BASIC = [
  { value: 'grams', label: 'Grammes (g)' },
  { value: 'kilograms', label: 'Kilogrammes (kg)' },
] as const;

export const DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'] as const;

export const DEFAULT_AVAILABILITY = {
  enable: true,
  startDateMorning: '08:00',
  closeDateMorning: '12:00',
  startingDateAfternoon: '14:00',
  closeDateAfternoon: '18:00',
} as const;

export const DEFAULT_DISABLED = {
  enable: false,
  startDateMorning: '',
  closeDateMorning: '',
  startingDateAfternoon: '',
  closeDateAfternoon: '',
} as const;

// Currency symbol mapping for display
export const CURRENCY_SYMBOL_MAP: Record<string, string> = {
  // Server format
  european_currency: '€',
  american_currency: '$',
  comoros_currency: 'KMF',
  // ISO codes
  EUR: '€',
  USD: '$',
  KMF: 'KMF',
  XAF: 'FCFA',
  XOF: 'FCFA',
  GBP: '£',
  MAD: 'DH',
  TND: 'DT',
  DZD: 'DA',
};

export const getCurrencySymbol = (currency: string): string => {
  return CURRENCY_SYMBOL_MAP[currency] || CURRENCY_SYMBOL_MAP[currency?.toUpperCase()] || currency;
};

// Type helpers
export type CurrencyValue = typeof CURRENCIES[number]['value'];
export type UnitValue = typeof UNITS[number]['value'];
export type GenderValue = typeof GENDERS[number]['value'];
export type WeightUnitValue = typeof WEIGHT_UNITS[number]['value'];
export type DayValue = typeof DAYS[number];
